import React from "react";
import classNames from "classnames";
import { getParkWebBannerText, isBannerEnabled } from "../../banner/Banner";
import TopBanner from "../../banner/TopBanner";
import { FooterParkWeb } from "../footer/FooterParkWeb";
import GetDomainButton from "../commonComponents/GetDomainButton";
import { useLanderConfig } from "../../commons/ConfigContext";
import { LanderConfig } from "../../types/LanderConfig";
import { AdContent } from "../AdContent";
import classes from "./ParkWebLayout.module.scss";

type ParkWebLayoutProps = {
  content: { [key: string]: string };
};

type DomainInfoProps = {
  landerConfig: LanderConfig;
  content: { [key: string]: string };
};

export function DomainInfo({ landerConfig, content }: DomainInfoProps) {
  const text = getParkWebBannerText(landerConfig, content);
  if (!text) return null;
  return <div className={ classes.domainInfo }>{text}</div>;
}

function Domain({ domain }: { domain: string }) {
  if (!domain) return null;
  return <div className={ classes.domain }>{domain}</div>;
}

export default function ParkWebLayout({ content }: ParkWebLayoutProps) {
  const { landerConfig } = useLanderConfig();
  const domain = landerConfig.domain?.rootDomainDisplayText;

  let domainContent = null;
  if (isBannerEnabled(landerConfig)) {
    domainContent = (
      <div data-testid="parkwebLayout" className={ classes.contentLayout }>
        <div className={ classes.domainStatusText }>
          <Domain domain={ domain } />
          <DomainInfo landerConfig={ landerConfig } content={ content } />
        </div>
        <div className={ classes.getDomain }>
          <GetDomainButton landerConfig={ landerConfig } />
        </div>
      </div>
    );
  }

  return (
    <div className={ classes.parkWebLander }>
      <TopBanner flexColumnOnMobile={ true } />
      <div className={ classes.contentMain }>
        <div className={ classes.domainCard }>{domainContent}</div>
      </div>
      <div className={ classNames(classes.contentSuggestions, classes.gdAds) }>
        <AdContent page="parkweb" />
      </div>
      <FooterParkWeb
        copyrightTextId="parkwebcopyrightText"
        parkwebDisclaimerText="parkwebDisclaimerText"
      />
    </div>
  );
}
